/*------------------------------------------------------------------------------
   About      : SSO Component opens in a new window and handles the redirect 
                from sso lambda. 
                It checks if the sso has return with an error. 
                Else, it reads the access token from query params. 
                It posts a message to the opener window with either the 
                accessToken or the error;

   Created on : Sun 19th Feb, 2023
   Author     : Sarang Gupta

   Copyright (c) 2023 Bidgely. All rights reserved.
------------------------------------------------------------------------------*/

import { useEffect } from 'react';

export interface SSOMessage{
  errorCode ?: string 
  accessToken ?: string
}
export default function SSOComponent(){
  useEffect(()=>{
    const params : any = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop : string) => searchParams.get(prop),
    });
    let ssoMessage : SSOMessage = {};
    if(params["error-code"]){
      ssoMessage["errorCode"] = params["error-code"];
    }
    if(params["token"]){
      ssoMessage["accessToken"] = params["token"];
    }
  window.opener.postMessage(ssoMessage)
  window.close();
  })
  return (
    <>
    {
      <div>Loading</div>
    }
    </>
  )
}